import { ActionButton, type ActionButtonProps } from '@/components/buttons';

type StyledToggleButtonProps = {
  isActive?: boolean;
};

export type ToggleButtonProps = StyledToggleButtonProps & Omit<ActionButtonProps, 'color'>;

export const ToggleButton = (props: ToggleButtonProps) => {
  const { isActive, ...restOfProps } = props;

  return <ActionButton isSelected={isActive} {...restOfProps} />;
};
